import { User } from '../components/modules/OrganizationCard';
import { SHARED_CONTENT_ENUM, VIDEOFEED_STATUS, VIDEOFEED_TYPE } from './ENUMS';
import { COMMENT, FILE_ACCESS_TYPE, FOLDER_TYPE, TOPIC, USER, VIDEOFEED } from './TYPES';

export enum CommentType {
  PARENT = 'parent',
  CHILD = 'child',
}

export enum CommentParentType {
  CLIP = 'clip',
  VIDEOFEED = 'videofeed',
  COMMENT = 'comment',
}

interface IComment {
  id: string;
  message: string;
  deleted_at?: string | null;
  parent_comment?: IComment;
  replies: IComment[];
  type: CommentType;
  parent_id: string;
  parent_type: CommentParentType;
  clip_id?: string;
  timestamp?: number;
  created_by: User;
  childrens: IComment[];
  clip: {
    id: string;
  };
}

export enum NOTIFICATION_TYPES {
  COMMENT = 'comment',
  TAGGED_COMMENT = 'tagged_comment',
  REPLY = 'reply',
  RENAME = 'rename',
  TAGGED_REPLY = 'tagged_reply',
  SHARED_COMPOSER = 'shared_composer',
  SHARED_ONLINE_COMPOSER = 'shared_online_composer',
  SHARED_TIMELINE = 'shared_timeline',
  SHARED_FOLDER = 'shared_folder',
  UPDATED_ACCESS = 'updated_access',
  CONTENT_OWNER_REPLACEMENT = 'content_owner_replacement',
  DELETED_COMMENT = 'deleted_comment',
  DELETED_CONTENT = 'deleted_content',
  TRANSCODE_EVENT = 'transcode_event',
  DOWNLOAD_TRANSCODE_EVENT = 'download_transcode_event',
}

export enum NOTIFICATION_CATEGORIES {
  VIDEOFEED = 'videofeed',
  FOLDER = 'folder',
  COMMENT = 'comment',
}

export interface CHILD_NOTIFICATION {
  id: string;
  category: NOTIFICATION_CATEGORIES;
  child_notifications: CHILD_NOTIFICATION[];
  comment: COMMENT;
  created_at: string;
  created_by: USER;
  isCleared: boolean;
  isRead: boolean;
  message: string;
  parent_notification: string;
  type: NOTIFICATION_TYPES;
  updated_at: string;
  user: string;
  videofeed: VIDEOFEED;
}

export interface TNOTIFICATION {
  category: NOTIFICATION_CATEGORIES;
  id: string;
  user: User;
  child_notifications: CHILD_NOTIFICATION[];
  custom_childs?: TNOTIFICATION[]; // frontend hack to display child notifications fully
  parent_notification: string;
  message: string;
  shared_content_message?: string;
  created_at: Date;
  created_by: USER;
  isRead: boolean;
  comment?: IComment;
  composer?: VIDEOFEED;
  folder?: FOLDER_TYPE;
  videofeed: {
    id: string;
    title: string;
    size?: number;
    type: VIDEOFEED_TYPE;
    videos: VIDEOFEED_TYPE[];
    topics: TOPIC[];
    comments: COMMENT[];
    created_by: USER;
    access: FILE_ACCESS_TYPE[];
    created_at: string;
    folder: FOLDER_TYPE;
    status?: VIDEOFEED_STATUS;
  };
  type: NOTIFICATION_TYPES;
  parent_type: 'clip';
  parent_id: string;
  custom_value?: string; // can be just a string or string json
}

export type RENOTIFY_BODY = {
  contentId: string;
  contentType: SHARED_CONTENT_ENUM;
  userIds: string[];
  groupIds: string[];
};
